module.exports = __webpack_public_path__ + "assets/img/menu-chirp.b362aef5.svg";